<template>
	<div class="errorPage">
		<nio-header-nav
			position="fixed"
			:is-white="true"
			:height.sync="headerHeight"
			@back="backToLastPage"
		/>
		<span class="error_icon"></span>
		<p class="error_text">你要找的页面不见啦！</p>
		<!-- <p class="error_text red">{{message}}</p>
    <p class="error_text red">{{resultDesc}}</p> -->
	</div>
</template>

<script>
import { baseMixin } from '@/supreme-core'
import hybrid from '@/util/nativeHybrid'
import util from '@/util/util'
export default {
	name: 'errorPage',
	mixins: [baseMixin],
	data() {
		return {
			headerIsShow: false,
			headerHeight: 0
		}
	},
	computed: {
		message() {
			return this.getQueryString('message')
		},
		resultDesc() {
			return this.getQueryString('resultDesc')
		},
		isInWebview() {
			return util.isInWebview()
		}
	},
	beforeRouteEnter(to, from, next) {
		let { header } = from.query
		let headers = (header && JSON.parse(header)) || { isShow: true }
		next(vm => {
			vm.headerIsShow = !headers.isShow
		})
	},
	methods: {
		backToLastPage() {
			if (util.isInWebview()) {
				hybrid.closeSyn()
			} else {
				this.$router.go(-2)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.errorPage {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	.error_icon {
		margin-top: 168px;
		width: 80px;
		height: 80px;
		background: url('../../assets/svg/error_page_bg.svg') center no-repeat;
	}
	.error_text {
		margin-top: 10px;
		font-size: 14px;
		color: #dddddd;
	}
	.red {
		color: #ff0033;
	}
}
</style>
